// src/features/dashboard/services/Employee/activityTimeline.service.ts

import api from '../../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../../api/endpoints';

import type {
  DailyActivityBreakdownApiResponse,
  DailyActivityBreakdownRequest,
} from '../../types/Employee/activityTimeline.types';

export const getActivityTimeline = async (
  payload: DailyActivityBreakdownRequest,
): Promise<DailyActivityBreakdownApiResponse> => {

  const response = await api.post(
    ENDPOINTS.EMPLOYEE_DAILY_ACTIVITY_BREAKDOWN,
    payload,
  );

  console.log(
    'ResponseActivity:',
    response.data,
  );

  return response.data;
};